/**
 * SectionHeading: eyebrow + h2 + optional description. Used across the site
 * to maintain consistent industrial rhythm.
 */
export default function SectionHeading({
    eyebrow,
    title,
    description,
    align = "left",
    accent = true,
    as: Tag = "h2",
    className = "",
    testId,
}) {
    return (
        <div
            className={`${className} ${align === "center" ? "text-center mx-auto max-w-3xl" : "text-left"}`}
            data-testid={testId}
        >
            {eyebrow && (
                <div
                    className={`inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.28em] text-cs-orange ${align === "center" ? "justify-center w-full" : ""}`}
                >
                    {accent && <span className="w-6 h-px bg-cs-orange" aria-hidden="true" />}
                    <span>{eyebrow}</span>
                    {accent && <span className="w-6 h-px bg-cs-orange" aria-hidden="true" />}
                </div>
            )}
            <Tag
                className={`font-heading font-extrabold uppercase tracking-tight text-cs-navy mt-3 text-3xl sm:text-4xl md:text-5xl leading-[1.02]`}
            >
                {title}
            </Tag>
            {description && (
                <p className="mt-4 text-cs-steel text-base leading-relaxed max-w-2xl">
                    {description}
                </p>
            )}
        </div>
    );
}
